const MB_fileManagement = {
  /**
   * Gets the file size from blob or url.
   * IMPORTANT: Try not to send blob when using mobile, it will cause problems with Android heap memory limitations.
   * @param blobOrUrl
   */
  getFileSize: async (blobOrUrl: Blob | string) => {
    if (typeof blobOrUrl === 'string') {
      const response = await fetch(blobOrUrl);
      const blob = await response.blob();
      return blob.size;
    }

    return blobOrUrl.size;
  },

  /**
   * NOTE: on web this function  does not do anything
   * @param path string path to the file
   */
  deleteFile: async (path: string) => {
    console.warn('Warning: on web deleteFile does not do anything. Not deleting file at path', path);
  },

  /**
   * NOTE: on web this function will just return an empty object.
   * @returns all available dirs for mobile.
   */
  getDirs: (): {} => {
    return {};
  },

  /**
   * Creates a directory at the provided path with the provided name.
   * NOTE: on web this function will just return an empty object.
   */
  createDirectory: async () => {
    return;
  },

  /**
   * Check the file at path is a directory or not. Resolves with false when the path is not a directory, or it does not exists.
   * NOTE: on web this function will just return false.
   */
  isDirectory: async (): Promise<boolean> => {
    return false;
  },

  /**
   * Check the file at path is a directory or not. Resolves with false when the path is not a directory, or it does not exists.
   * NOTE: on web this function will just return an empty array.
   */
  ls: async (): Promise<string[]> => {
    return [];
  },

  /**
   * Deletes all the files in a given directory
   * NOTE: on web this function will just return.
   */
  deleteDirectoryContents: async () => {
    return;
  },
};

export { MB_fileManagement };
